import { scrollToHash, isMobileOrTablet } from '../utils';
import gsap from 'gsap';

// 記述が多いのもはimport
import { registerBreakPointEvent } from './registerBreakPointEvent';

/**
 * @function rewriteTellink
 * @description PCの場合、<a href="tel:">を<span>に変更、class等attributeはそのまま継承
 * */
const _rewriteAtag = (el: HTMLElement): void => {
  const attributes = el.attributes;
  const innerHtml = el.innerHTML;
  let attributesText = null;
  for (let i = 0; i < attributes.length; i++) {
    const attribute = attributes[i];
    if (attribute.name != 'href') {
      const t = `${attribute.name}="${attribute.textContent}"`;
      attributesText = attributesText == null ? t : `${t} ${attributesText}`;
    }
  }
  if (attributesText == null) {
    el.outerHTML = `<span>${innerHtml}</span>`;
  } else {
    el.outerHTML = `<span ${attributesText}>${innerHtml}</span>`;
  }
};

const rewriteTellink = () => {
  const tel_links = document.querySelectorAll('a[href^="tel:"]') as NodeListOf<HTMLElement>;
  if (tel_links.length && !isMobileOrTablet()) {
    tel_links.forEach((tel_link) => {
      _rewriteAtag(tel_link);
    });
  }
};

/**
 * @function smoothScroll
 * @description ページ内リンクのスムーススクロール
 * */

const smoothScroll = (): void => {
  const anchor_links = document.querySelectorAll('a[href^="#"]') as NodeListOf<HTMLElement>;
  if (anchor_links.length) {
    anchor_links.forEach((anchor_link) => {
      anchor_link.addEventListener('click', (e) => {
        const hash = anchor_link.getAttribute('href');
        if (hash) {
          scrollToHash(hash, e);
        }
      });
    });
  }
  if (location.hash) {
    scrollToHash(location.hash, null);
  }
};

/**
 * @function adjustViewport
 * @description viewport 375px以下は width=375 で固定にする
 * */
const adjustViewport = (): void => {
  const triggerWidth = 375;
  const viewport = document.querySelector('meta[name="viewport"]');
  const value = window.outerWidth < triggerWidth ? `width=${triggerWidth}, target-densitydpi=device-dpi` : 'width=device-width, initial-scale=1,maximum-scale=1.0';
  if (viewport) {
    viewport.setAttribute('content', value);
  } else {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = value;
    document.head.appendChild(meta);
  }
};
/**
 * @function setRootProperty
 * @description :root{  }に動的なcss変数を設定
 * */
const setRootProperty = (): void => {
  const root = document.querySelector(':root') as HTMLElement;
  if (root) {
    const window_width = document.body.clientWidth;
    root.style.setProperty('--view-width', `${window_width}px`);
    const html_font_times = window_width / 1000 > 1 ? 1 : window_width / 1000;
    root.style.setProperty('--font-size-times', String(html_font_times));
  }
};

/**
 * @function handleNav
 * */

const handleNav = (): void => {
  const toggles = document.querySelectorAll('[data-nav-toggle]') as NodeListOf<HTMLElement>;
  const opens = document.querySelectorAll('[data-nav-open]') as NodeListOf<HTMLElement>;
  const closes = document.querySelectorAll('[data-nav-close]') as NodeListOf<HTMLElement>;
  if (toggles.length) {
    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        if (document.body.classList.contains('is-nav-open')) {
          _closeNav();
        } else {
          _openNav();
        }
      });
    });
  }
  if (opens.length) {
    opens.forEach((el) => {
      el.addEventListener('click', _openNav);
    });
  }
  if (closes.length) {
    closes.forEach((el) => {
      el.addEventListener('click', _closeNav);
    });
  }
};
const _openNav = () => {
  const gnav = document.getElementById('Gnav');
  document.body.style.overflow = 'hidden';
  document.body.classList.add('is-nav-open');
  gsap.to(gnav, {
    autoAlpha: 1,
  });
};
const _closeNav = () => {
  const gnav = document.getElementById('Gnav');
  document.body.style.overflow = '';
  document.body.classList.remove('is-nav-open');
  gsap.to(gnav, {
    autoAlpha: 0,
  });
};

/**
 * @function toggleClassHeader
 * */
const toggleClassHeader = (): void => {
  if (window.scrollY > 200) {
    document.body.classList.add('is-header-scrolled');
  } else {
    document.body.classList.remove('is-header-scrolled');
  }
};

// export object
const Common = {
  init() {
    registerBreakPointEvent();
    adjustViewport();
    setRootProperty();
    rewriteTellink();
    smoothScroll();
    handleNav();
  },
  resize() {
    adjustViewport();
    setRootProperty();
  },
  scroll() {
    toggleClassHeader();
  },
  breakPoint() {},
};

export { Common };
